import axios from "axios";

const baseURL = process.env.NODE_ENV==="production"?"https://paulinesafrica.org/api/v1/":"http://127.0.0.1:8000/api/v1"

const axiosInstance = axios.create({
  baseURL,  
  // You can also set other default configurations here if needed
});

export default axiosInstance;
